import React, { createContext, useState } from 'react';

type BreadcrumbsType = {
  view: string;
  message: string;
  href: string;
  labels: string[];
  title: string;
};

export type BreadcrumbsContextType = {
  breadcrumbs: BreadcrumbsType;
  updateBreadcrumbs: (data: BreadcrumbsType) => void;
};

export const BreadcrumbsContext = createContext<BreadcrumbsContextType | null>(
  null,
);

type Props = {
  children: React.ReactNode;
};

export const BreadcrumbsProvider = ({ children }: Props) => {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbsType>({
    view: '',
    message: '',
    href: '',
    labels: [],
    title: '',
  });

  const updateBreadcrumbs = (data: BreadcrumbsType) => {
    setBreadcrumbs(data);
  };

  return (
    <BreadcrumbsContext.Provider
      value={{
        breadcrumbs,
        updateBreadcrumbs,
      }}
    >
      {children}
    </BreadcrumbsContext.Provider>
  );
};
